import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'; // Assuming this is your main application CSS

// Import your components
import AboutUs from './Components/AboutUsComp/aboutus.js';
import Bookings from './Components/BookingComp/bookings.js';
import ContactUs from './Components/ContactUsComp/contactus.js';
import Gallery from './Components/GalleryComp/gallery.js';
import HomeComp from './Components/HomeComp/home.js';


import Footer from './Components/MainComp/Footer.js';
import Navbar from './Components/MainComp/Navbar.js';
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton.js';
import Destination from './Components/DestinationComp/destination.js';

import Tour4 from './Components/TourpackagesComp/tour4.js';
import Tour6 from './Components/TourpackagesComp/tour6.js';
import Tour7 from './Components/TourpackagesComp/tour7.js';
import Tour12 from './Components/TourpackagesComp/tour12.js';
import Tour14 from './Components/TourpackagesComp/tour14.js'; 
import AirportPickupDrop from './Components/TourpackagesComp/airport-pickup-drop.js';


import ScrollToTop from './ScrollComp/ScrollToTop';




function App() {
  return (
    <Router>
       <ScrollToTop />
      <Navbar />
      <div className="App">
  
        
        <Routes>
       
          <Route path="/" element={<HomeComp />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path='/destination' element={<Destination />} />
          <Route path='/tour4' element={<Tour4 />} />
          <Route path='/tour6' element={<Tour6 />} />
          <Route path='/tour7' element={<Tour7 />} />
          <Route path='/tour12' element={<Tour12 />} />
          <Route path='/tour14' element={<Tour14 />} />
          <Route path='/airport-pickup-drop' element={<AirportPickupDrop />} />
    
          
          {/* You can add a catch-all route for a 404 page */}
          {/* <Route path="*" element={<NotFoundPage />} /> */}
        </Routes>
        
       
      </div>
      <Footer />
      <WhatsAppButton />
    </Router>
  );
}

export default App;